/* @flow weak */
import * as React from 'react';
import { graphql } from 'react-apollo';

import AuthenticationView from 'auth/components/AuthenticationView';
import Button from 'components/ButtonDeprecated';
import Link from 'components/Link';
import MERGE_DIRECT_ADDEE_PAGE_QUERY from 'auth/queries/MergeDirectAddeePageQuery.gql';
import Redirect from 'components/Redirect';
import TitleHeader from 'components/TitleHeader';
import UserAgent from 'lib/UserAgent';

import type { MergeDirectAddeePage as MergeDirectAddeePageQuery } from 'auth/queries/__generated__/MergeDirectAddeePage';

import './styles/MergeDirectAddeePage.scss';

type Props = {
  data: ReactApolloData<MergeDirectAddeePageQuery>,
  params: { token: string },
  error?: *,
};

export class MergeDirectAddeePage extends React.Component<Props> {
  render() {
    const { token } = this.props.params;
    const {
      data: { user, error },
    } = this.props;

    if (user) {
      return <Redirect to={`/classes?email_token=${token}`} />;
    }

    // If there's a 401 error, the user is logged out so we show the logged out flow
    if (error) {
      const userAgent = new UserAgent(window.navigator.userAgent);
      return (
        <AuthenticationView>
          <TitleHeader
            title="Have you used Remind before?"
            image={require('assets/images/book-phone.svg')}
            imageClassName="MergeDirectAddeePage-image"
          />
          <Button
            full
            className="MergeDirectAddeePage-merge"
            eventElementName="MergeDirectAddeePage-merge"
            to={`/log_in/?email_token=${token}`}>
            Yes, I have
          </Button>
          <Button
            full
            className="MergeDirectAddeePage-cancel"
            eventElementName="MergeDirectAddeePage-cancel"
            color="mascot"
            level="secondary"
            to={`/confirm_email/${token}`}>
            No, I am new to Remind
          </Button>
          {userAgent.ios() ? (
            <Link
              className="MergeDirectAddeePage-app"
              weight="semibold"
              block
              href={`rmd://direct_addee/${token}`}>
              I already have the app
            </Link>
          ) : null}
        </AuthenticationView>
      );
    }

    return null;
  }
}

const withUser = graphql(MERGE_DIRECT_ADDEE_PAGE_QUERY, {
  options: { fetchPolicy: 'network-only' },
});

export default withUser(MergeDirectAddeePage);
